import { css } from 'styled-components';

import RethinkSansRegular from "./RethinkSans-Regular.ttf";
import RethinkSansMedium from "./RethinkSans-Medium.ttf";
import RethinkSansSemiBold from "./RethinkSans-SemiBold.ttf";
import RethinkSansBold from "./RethinkSans-Bold.ttf";

export default css`
  @font-face {
    font-family: "RethinkSans";
    src: url(${RethinkSansRegular}) format("truetype");
    font-style: normal;
    font-weight: 400;
  }

  @font-face {
    font-family: "RethinkSans";
    src: url(${RethinkSansMedium}) format("truetype");
    font-style: normal;
    font-weight: 500;
  }

  @font-face {
    font-family: "RethinkSans";
    src: url(${RethinkSansSemiBold}) format("truetype");
    font-style: normal;
    font-weight: 600;
  }

  @font-face {
    font-family: "RethinkSans";
    src: url(${RethinkSansBold}) format("truetype");
    font-style: normal;
    font-weight: 700;
  }
`;
